module.exports = __webpack_public_path__ + "static/banner-e2eb5d7fc2316f50f7c6fe347c930a51.jpg";